import React from "react"
import { translate } from "react-i18next"
import PropTypes from "prop-types"
import Widget from "../layout/widget/Widget"
import ColumnChart from "../charts/generic/ColumnChart"
import { formatDecimalForDisplay } from "../../utils/formatting-utils"

function HappyScale({ exportEndpoint, appliedFilters, data, t, subtitleKey, sampleSize }) {
  const formatTooltip = context => {
    if (context.point.count === 1) {
      return `<b>${context.x}:</b> 
      ${formatDecimalForDisplay(context.y)}% (${context.point.count} ${t("Common.Person")})`
    }
    
    return `<b>${context.x}:</b> 
    ${formatDecimalForDisplay(context.y)}% (${context.point.count} ${t("Common.People")})`
  }

  const barChartData = {
    categories: [],
    bars: []
  }

  const singleDataItem = {
    data: [],
    showInLegend: false
  }

  if (data.dataSets[0] && data.dataSets[0].data && data.dataSets[0].data.length > 0) {
    data.dataSets[0].data.forEach(d => {
      barChartData.categories.push(d.itemName)
      singleDataItem.data.push({ y: d.percentage, count: d.count })
    })
    barChartData.bars.push(singleDataItem)
  }

  const titleKey = "Widgets.HappyScale.Title"
  return (
    <Widget
      columns={2}
      titleKey={titleKey}
      helpKey="Widgets.HappyScale.Help"
      exportEndpoint={exportEndpoint}
      appliedFilters={appliedFilters}
      subtitleKey={subtitleKey}
      sampleSize={sampleSize}
    >
      <ColumnChart
        data={barChartData}
        yAxisTitle="Common.Percentage"
        xAxisTitle="Common.Score"
        chartType="column"
        tooltipFormatter={formatTooltip}
        titleKey={titleKey}
        subtitleKey={subtitleKey}
      />
    </Widget>
  )
}

HappyScale.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.shape({
    value: PropTypes.number,
    key: PropTypes.string
  }).isRequired,
  exportEndpoint: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  subtitleKey: PropTypes.string,
  sampleSize: PropTypes.object
}

export default translate()(HappyScale)



// WEBPACK FOOTER //
// ./src/components/widgets/HappyScale.jsx